/* hai-quick-add — agregar al carrito desde cualquier tarjeta sin salir de la
   página. Principio de siempre: alimentar el control del tema, no
   reemplazarlo. El botón sigue siendo el <add-to-cart> de Avante (hace el
   fetch, actualiza el drawer y la burbuja del header); aquí solo:
     1. se mueve el bloque de botones al final del contenido de la card
        (el tema lo esconde bajo la imagen y solo lo sube con hover);
     2. al confirmar el alta (evento ajaxProduct:added del tema) la miniatura
        vuela al ícono del carrito, el ícono rebota y sale un aviso breve.
   El drawer NO se abre en el alta rápida: para eso las cards llevan la clase
   hai-quick-add en vez de cart-drawer (card-product.liquid). En la ficha
   tampoco (Andrés, 25-oct-2026, opción A): agregar cuenta lo mismo que en las
   tarjetas, sin abrir el carrito (bloque 3). */
(() => {
  const REDUCIDO = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Cuánto se ve el "✓ Agregado" en verde antes de que entre el contador
  // (bloque 6). Sin este compás el botón se desvanecía antes de ponerse verde
  // (Andrés, 09-sep-2026). El contador llega con borde verde y se apaga solo.
  const VERDE_MS = REDUCIDO ? 0 : 400;
  let pendiente = null;

  /* ---- 1. Botón visible bajo el precio ---- */
  const SIN_HOVER = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);
  // Botones fuera del enlace (25-oct-2026, tema B): la tarjeta es un <a> y un <button> dentro de un enlace es
  // HTML inválido (el lector de pantalla los mezcla y el toque depende de preventDefault). El bloque va al final
  // de .card-container, después del enlace y dentro del mismo marco. En el buscador sigue dentro del contenido:
  // sus filas tienen su propio diseño (hai-navigation.css).
  const recolocar = () => {
    document.querySelectorAll('.card .card__extras').forEach((extras) => {
      const card = extras.closest('.card');
      const marco = card && card.closest('.card-container');
      if (marco && !extras.closest('.search-modal, predictive-search')) {
        marco.appendChild(extras);
        return;
      }
      const contenido = card && card.querySelector('.card__content');
      if (!contenido || extras.parentElement === contenido) return;
      contenido.appendChild(extras);
    });
    // En pantallas táctiles la tarjeta lleva la clase no-hover del tema: sin
    // efecto de segunda foto al pasar el mouse, iOS no convierte el primer
    // toque en "hover" (la ficha navega y Agregar agrega al primer toque).
    if (SIN_HOVER) document.querySelectorAll('.card.card-js:not(.no-hover)').forEach((card) => card.classList.add('no-hover'));
  };

  /* ---- 2. Feedback al agregar ---- */
  const iconoCarrito = () =>
    [...document.querySelectorAll('.cart-block')].find((el) => el.offsetParent && el.getBoundingClientRect().width > 0);

  const volar = (img, destino) => new Promise((listo) => {
    const a = img.getBoundingClientRect();
    const b = destino.getBoundingClientRect();
    if (!a.width || !b.width) return listo();
    const clon = img.cloneNode(true);
    clon.className = 'hai-fly';
    Object.assign(clon.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
    document.body.appendChild(clon);
    const dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    const dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    const escala = Math.max(0.12, Math.min(0.25, 40 / a.width));
    const anim = clon.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1, offset: 0 },
        { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 60}px) scale(${(1 + escala) / 2})`, opacity: 0.95, offset: 0.55 },
        { transform: `translate(${dx}px, ${dy}px) scale(${escala})`, opacity: 0.4, offset: 1 }
      ],
      { duration: 650, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)', fill: 'forwards' }
    );
    anim.onfinish = () => { clon.remove(); listo(); };
    anim.oncancel = () => { clon.remove(); listo(); };
  });

  const rebotar = (el) => {
    if (REDUCIDO || !el.animate) return;
    el.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(0.96)' }, { transform: 'scale(1)' }],
      { duration: 460, easing: 'ease-out' }
    );
  };

  let toastNodo = null;
  let toastTimer = null;
  // Aviso con contexto: miniatura y nombre del producto + "Agregado al
  // carrito" + Ver carrito. En móvil es una barra abajo, en escritorio una
  // pastilla centrada (ver hai-quick-add.css).
  const aviso = (texto, esError, producto) => {
    if (!toastNodo) {
      toastNodo = document.createElement('div');
      toastNodo.className = 'hai-toast';
      toastNodo.setAttribute('role', 'status');
      toastNodo.setAttribute('aria-live', 'polite');
      toastNodo.innerHTML =
        '<span class="hai-toast__thumb"></span>' +
        '<span class="hai-toast__cuerpo"><span class="hai-toast__titulo"></span><span class="hai-toast__texto"></span><span class="hai-toast__envio" hidden></span></span>' +
        '<button type="button" class="hai-toast__link">Ver carrito</button>';
      toastNodo.querySelector('.hai-toast__link').addEventListener('click', () => {
        const icono = iconoCarrito();
        const link = icono && icono.querySelector('a, button');
        if (link) link.click(); else window.location.href = '/cart';
      });
      document.body.appendChild(toastNodo);
    }
    const thumb = toastNodo.querySelector('.hai-toast__thumb');
    const titulo = toastNodo.querySelector('.hai-toast__titulo');
    thumb.innerHTML = producto && producto.src ? '<img src="' + producto.src + '" alt="">' : '';
    thumb.hidden = !(producto && producto.src);
    titulo.textContent = (producto && producto.titulo) || '';
    titulo.hidden = !titulo.textContent;
    toastNodo.querySelector('.hai-toast__texto').textContent = texto;
    // La línea de envío gratis la pone pintarEnvio (bloque 7) cuando llega el carrito.
    const envio = toastNodo.querySelector('.hai-toast__envio');
    if (envio) { envio.hidden = true; envio.innerHTML = ''; }
    toastNodo.classList.toggle('hai-toast--error', !!esError);
    toastNodo.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastNodo.classList.remove('is-visible'), 3600);
  };

  const etiquetaDe = (boton) => {
    const btn = boton && boton.querySelector('.card__add-to-cart');
    const label = btn && btn.querySelector('.hai-quick-add__label');
    if (!btn || !label || btn.disabled) return null;
    if (!label.dataset.original) label.dataset.original = label.textContent;
    return { btn, label };
  };

  const restaurar = (boton) => {
    const e = etiquetaDe(boton);
    if (!e) return;
    e.btn.classList.remove('is-agregado');
    e.label.textContent = e.label.dataset.original;
  };

  const confirmarEnBoton = (boton) => {
    const e = etiquetaDe(boton);
    if (!e) return;
    e.btn.classList.add('is-agregado');
    e.label.textContent = 'Agregado';
    setTimeout(() => restaurar(boton), 1400);
  };

  document.addEventListener('click', (event) => {
    const boton = event.target.closest && event.target.closest('add-to-cart.hai-quick-add');
    if (!boton || boton.querySelector('button[disabled]')) return;
    // El ayudante oculto del hero ya dejó su propio "pendiente".
    if (boton.classList.contains('hai-quick-add--oculto')) return;
    // 09-sep-2026 (noche, Andrés): dentro del modal de búsqueda la tarjeta
    // vive en el <form> del buscador y en iPhone el toque terminaba ENVIANDO
    // ese formulario (aterrizaba en /search) en vez de agregar. Aquí, en
    // captura y antes que nadie, se toma el mando: se cancela cualquier
    // envío, se corta la propagación (así no corre además el listener del
    // componente y no hay alta doble) y se llama directo al alta del tema.
    // Guarda de 600 ms por si llegan el clic sintético del toque y el nativo.
    let directo = false;
    if (boton.closest('.search-modal')) {
      event.preventDefault();
      event.stopPropagation();
      const ahora = Date.now();
      if (ahora - Number(boton.dataset.haiUltimoClic || 0) < 600) return;
      boton.dataset.haiUltimoClic = String(ahora);
      directo = typeof boton.onClickHandler === 'function';
    }
    const card = boton.closest('.card-container, .card, [data-hai-card]');
    const img = card && card.querySelector('.card__picture-wrapper img:not(.hai-fly), [data-hai-card-img]');
    const icono = iconoCarrito();
    // Dentro del drawer del carrito no hay vuelo: el ícono queda tapado y la
    // fila nueva aparece en la lista, que es la confirmación natural.
    const enDrawer = !!boton.closest('cart-drawer');
    // Fluidez: el vuelo arranca en el clic, no al volver la respuesta del
    // servidor (300–600 ms). Si el alta falla, el aviso de error lo dice.
    const vuelo = (!REDUCIDO && !enDrawer && img && icono)
      ? Promise.race([volar(img, icono), new Promise((r) => setTimeout(r, 900))])
      : Promise.resolve();
    // El botón habla mientras espera: "Agregando…" (la franja la pone el CSS
    // sobre la clase .loading que agrega el tema).
    const e = etiquetaDe(boton);
    if (e) e.label.textContent = 'Agregando…';
    // Primero el texto del nombre: en las tarjetas de colección .card__title
    // envuelve también el precio ("MagneZen Precio normal Desde $14.990").
    const tituloNodo = card && (card.querySelector('.card__title-text, [data-hai-card-title]') ||
      card.querySelector('.card__title, .card__heading'));
    const producto = {
      src: img ? (img.currentSrc || img.src) : '',
      titulo: tituloNodo ? tituloNodo.textContent.replace(/\s+/g, ' ').replace(/\s*\[.*$/, '').trim() : ''
    };
    pendiente = { boton, icono, vuelo, producto, t: Date.now() };
    // Contador (bloque 6): releer el carrito cuando el tema termine el alta,
    // haya o no evento ajaxProduct:added. El tema pone .loading al empezar y
    // lo quita en su finally, con éxito o con error; se observa eso.
    if (boton.dataset.haiEscalera) {
      const obs = new MutationObserver(() => {
        if (boton.classList.contains('loading')) return;
        obs.disconnect();
        resincronizar(VERDE_MS);
      });
      obs.observe(boton, { attributes: true, attributeFilter: ['class'] });
      setTimeout(() => obs.disconnect(), 15000);
    }
    // El alta directa va al final: `pendiente` y el observador ya quedaron
    // armados para el ajaxProduct:added que va a llegar.
    if (directo) boton.onClickHandler(boton);
  }, true);

  /* ---- 2b. Hero: "LO QUIERO" agrega directo ---- */
  // Los botones del slideshow que enlazan a un producto y dicen "Lo quiero"
  // agregan la primera variante disponible sin salir de la home. Los demás
  // ("Ver beneficios", "Me interesa") siguen siendo enlaces. Convención por
  // copy: basta escribir "Lo quiero" en el editor para que un slide venda.
  const HERO_SEL = '.slideshow-section a.solid-button[href*="/products/"]';
  const esLoQuiero = (a) => /^\s*lo quiero\s*$/i.test(a.textContent);
  const marcarHero = () => {
    document.querySelectorAll(HERO_SEL).forEach((a) => {
      if (esLoQuiero(a)) a.classList.add('hai-hero-add');
    });
  };
  const restaurarHero = (a) => {
    if (!a) return;
    a.classList.remove('loading', 'is-agregado');
    if (a.dataset.haiOriginal) a.textContent = a.dataset.haiOriginal;
    delete a.dataset.haiBusy;
  };

  document.addEventListener('click', (event) => {
    const a = event.target.closest && event.target.closest(HERO_SEL);
    if (!a || !esLoQuiero(a) && !a.classList.contains('hai-hero-add')) return;
    event.preventDefault();
    event.stopPropagation();
    if (a.dataset.haiBusy) return;
    a.dataset.haiBusy = '1';
    if (!a.dataset.haiOriginal) a.dataset.haiOriginal = a.textContent;
    a.classList.add('loading');
    a.textContent = 'Agregando…';
    const slide = a.closest('[class*="slideshow__slide"]') || a.closest('.slideshow-section');
    const img = slide && slide.querySelector('img.context__image-item, img');
    const handle = (a.getAttribute('href') || '').split('/products/')[1].split(/[?#]/)[0];
    const icono = iconoCarrito();
    const vuelo = (!REDUCIDO && img && icono)
      ? Promise.race([volar(img, icono), new Promise((r) => setTimeout(r, 900))])
      : Promise.resolve();
    // El nombre sale del producto (fetch .js), no del slide: el texto del hero
    // es un eyebrow o un titular, no el nombre. Se cachea junto a la variante.
    const producto = { src: img ? (img.currentSrc || img.src) : '', titulo: a.dataset.haiTitulo || '' };

    const lanzar = (variantId) => {
      // Ayudante: un <add-to-cart> del tema fuera de la vista. Hace el fetch
      // con las secciones del drawer y la burbuja, y dispara ajaxProduct:added.
      const ayudante = document.createElement('add-to-cart');
      ayudante.className = 'hai-quick-add hai-quick-add--oculto';
      ayudante.dataset.variantId = variantId;
      ayudante.hidden = true;
      ayudante.innerHTML = '<button type="button" class="quick"></button>';
      document.body.appendChild(ayudante);
      pendiente = { boton: null, hero: a, icono, vuelo, producto, t: Date.now() };
      ayudante.click();
      setTimeout(() => ayudante.remove(), 15000);
    };

    if (a.dataset.haiVariant) { lanzar(a.dataset.haiVariant); return; }
    fetch('/products/' + handle + '.js')
      .then((r) => r.json())
      .then((p) => {
        const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0];
        if (!v) throw new Error('sin variante');
        a.dataset.haiVariant = v.id;
        a.dataset.haiTitulo = (p.title || '').replace(/\s*\[.*$/, '').trim();
        producto.titulo = a.dataset.haiTitulo;
        lanzar(v.id);
      })
      .catch(() => { restaurarHero(a); aviso('No se pudo agregar. Intenta de nuevo.', true); });
  }, true);

  document.addEventListener('ajaxProduct:added', () => {
    if (!pendiente || Date.now() - pendiente.t > 8000) return;
    const p = pendiente;
    pendiente = null;
    aviso('Agregado al carrito', false, p.producto);
    envioEsperado = Date.now();
    confirmarEnBoton(p.boton);
    // Contador (bloque 6): pintar YA con la cantidad nueva y el precio que
    // Shopify dio al renderizar; el carrito se relee en segundo plano y
    // corrige si hiciera falta. Antes se esperaba 650 ms y una segunda
    // llamada: el contador tardaba 1,5 s en aparecer.
    if (p.boton && p.boton.dataset.haiEscalera) {
      const pasos = escaleraDe(p.boton);
      const paso = pasos.find((x) => String(x.id) === String(p.boton.dataset.variantId));
      const u = parseInt(p.boton.dataset.haiQty || '0', 10) + (paso ? paso.n : 1);
      const est = descomponer(u, pasos);
      setTimeout(() => {
        pintarContador(p.boton, { u, total: est ? est.costo : 0, comboN: est ? est.comboN : 0 });
        const extras = p.boton.closest('.card__extras');
        const stepper = extras && extras.querySelector('.hai-stepper');
        if (stepper) {
          stepper.classList.add('is-recien');
          setTimeout(() => stepper.classList.remove('is-recien'), 900);
        }
      }, VERDE_MS);
      resincronizar(VERDE_MS);
    }
    if (p.hero) {
      p.hero.classList.remove('loading');
      p.hero.classList.add('is-agregado');
      p.hero.textContent = '✓ Agregado';
      setTimeout(() => restaurarHero(p.hero), 1400);
    }
    p.vuelo.then(() => { if (p.icono) rebotar(p.icono); });
  });

  document.addEventListener('ajaxProduct:error', (event) => {
    if (!pendiente) return;
    restaurar(pendiente.boton);
    restaurarHero(pendiente.hero);
    pendiente = null;
    const msg = event.detail && event.detail.errorMessage;
    aviso(msg || 'No se pudo agregar. Intenta de nuevo.', true);
  });

  /* ---- 3. Ficha de producto: el botón grande cuenta la misma historia ---- */
  // El product-form del tema no dispara ajaxProduct:added: publica
  // cartUpdate por su pub/sub. Se escucha eso; y como respaldo se observa
  // cuándo el tema le quita .loading al botón (sin mensaje de error = ok).
  // Agregar en la ficha no abre el carrito (Andrés, 25-oct-2026, opción A: el
  // 71 % de los pedidos lleva 2 o más productos y abrirlo corta la compra). El
  // drawer se abre solo tras cada alta si trae la clase open-after-adding (ajuste
  // «Acción después de agregar» del tema, cart-drawer.js): en la ficha se le quita
  // una vez y vale para el botón grande, la barra fija y «Quiero esta rutina». Al
  // refrescarse cambia solo su interior (#CartDrawer), así que la clase no vuelve;
  // el ícono del carrito lo sigue abriendo. En su lugar sale el aviso de las
  // tarjetas, con la foto, el nombre y lo que falta para el envío gratis.
  const ENFICHA = !!document.querySelector('.product__info-container');
  if (ENFICHA) {
    const cajon = document.querySelector('cart-drawer');
    if (cajon) cajon.classList.remove('open-after-adding');
  }
  // Nombre (el texto directo del h1: el formato va en su propio span) y la foto que se ve de la escena (la otra
  // copia es un GIF de 1 px).
  const productoFicha = () => {
    const h1 = document.querySelector('.product__info-container h1');
    const titulo = h1 ? [...h1.childNodes].filter((n) => n.nodeType === 3).map((n) => n.textContent).join('').trim() : '';
    const img = [...document.querySelectorAll('.hai-escena__lamina img, .product__media img')]
      .find((i) => i.getBoundingClientRect().width > 1 && !/^data:/.test(i.currentSrc || i.src));
    return { titulo, src: img ? (img.currentSrc || img.src) : '' };
  };
  let pdp = null;
  const tituloPdp = (btn) => btn && btn.querySelector('.button-title');
  const restaurarPdp = () => {
    if (!pdp) return;
    const t = tituloPdp(pdp.btn);
    pdp.btn.classList.remove('is-agregado');
    if (t && t.dataset.original) t.textContent = t.dataset.original;
    pdp = null;
  };
  const confirmarPdp = () => {
    if (!pdp || pdp.confirmado) return;
    pdp.confirmado = true;
    const t = tituloPdp(pdp.btn);
    pdp.btn.classList.add('is-agregado');
    if (t) t.textContent = 'Agregado';
    const icono = iconoCarrito();
    if (icono) setTimeout(() => rebotar(icono), 250);
    if (ENFICHA) {
      aviso('Agregado al carrito', false, productoFicha());
      envioEsperado = Date.now();
      resincronizar(0);
    }
    setTimeout(restaurarPdp, 1400);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.closest || !form.closest('product-form')) return;
    const btn = form.querySelector('.product-form__submit');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    // La barra fija pierde .button-title al cambiar de combo (el tema rehace su botón): sin título no se cambia la
    // etiqueta, pero el aviso sale igual.
    const t = tituloPdp(btn);
    if (t) {
      if (!t.dataset.original) t.dataset.original = t.textContent.trim();
      t.textContent = 'Agregando…';
    }
    pdp = { btn, t: Date.now(), confirmado: false };
    const obs = new MutationObserver(() => {
      if (btn.classList.contains('loading')) return;
      obs.disconnect();
      setTimeout(() => {
        if (!pdp || pdp.btn !== btn) return;
        const err = form.querySelector('.form__message, .product-form__error-message, [id^="ProductError"]');
        const hayError = err && !err.classList.contains('hidden') && err.textContent.trim();
        if (hayError) restaurarPdp(); else confirmarPdp();
      }, 60);
    });
    obs.observe(btn, { attributes: true, attributeFilter: ['class'] });
  }, true);

  // (typeof: PUB_SUB_EVENTS es un const de global.js y no cuelga de window.)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (d) => { if (d && d.source === 'product-form') confirmarPdp(); });
  }

  /* ---- 4. "Quiero probarlas": varios productos de una vez ---- */
  // Un botón con data-hai-agregar="id,id,…" (la sección hai-aili lo arma desde
  // una colección) manda todos los ítems en UN /cart/add.js. Se reutiliza el
  // <add-to-cart> del tema como ayudante para pedir y pintar las secciones del
  // drawer y la burbuja; el drawer se abre porque su renderContents lo hace,
  // salvo en la ficha («Quiero esta rutina»: ver bloque 3), donde basta el aviso.
  document.addEventListener('click', (event) => {
    const btn = event.target.closest && event.target.closest('[data-hai-agregar]');
    if (!btn) return;
    event.preventDefault();
    if (btn.dataset.haiBusy) return;
    const ids = btn.dataset.haiAgregar.split(',').map((x) => parseInt(x, 10)).filter(Boolean);
    if (!ids.length) return;
    btn.dataset.haiBusy = '1';
    btn.classList.add('loading');
    const e = etiquetaDe(btn);
    if (e) e.label.textContent = 'Agregando…';
    const ayudante = document.createElement('add-to-cart');
    ayudante.className = 'hai-quick-add hai-quick-add--oculto';
    ayudante.hidden = true;
    document.body.appendChild(ayudante);
    const mini = document.querySelector('cart-drawer');
    const secciones = []
      .concat(mini && mini.getSectionsToRender ? mini.getSectionsToRender() : [])
      .concat(ayudante.getSectionsToRender());
    const idsSecciones = [...new Set(secciones.map((x) => x.id))];
    const icono = iconoCarrito();
    const raiz = btn.closest('[data-hai-card], .hai-aili');
    const img = raiz && raiz.querySelector('[data-hai-card-img], .hai-aili__media img');
    const producto = { src: img ? (img.currentSrc || img.src) : '', titulo: btn.dataset.haiTitulo || '' };
    pendiente = { boton: btn, icono, vuelo: Promise.resolve(), producto, t: Date.now() };
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })), sections: idsSecciones, sections_url: window.location.pathname })
    })
      .then((r) => r.json())
      .then((estado) => {
        if (estado.status === 422 || estado.status >= 400) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: estado.description || estado.message } }));
          return;
        }
        try { if (mini && mini.renderContents) mini.renderContents(estado); } catch (err) { /* sin drawer */ }
        try { ayudante.renderContents(estado); } catch (err) { /* burbuja ya pintada por el drawer */ }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: estado } }));
      })
      .catch(() => document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: {} })))
      .finally(() => {
        btn.classList.remove('loading');
        delete btn.dataset.haiBusy;
        ayudante.remove();
      });
  }, true);

  /* ---- 6. Contador de unidades en la tarjeta ---- */
  // Tras el alta, el botón se convierte en un contador (− n +). El estado sale
  // SIEMPRE del carrito: Liquid lo pinta al renderizar (data-hai-qty / total /
  // combo, card-product.liquid) y después de cada cambio se relee de la
  // respuesta de la API. El código no conoce precios: la tarjeta declara sus
  // pasos de escalera [{n, id, p, a}] con el precio que Shopify dio al
  // renderizar, y el script solo elige la combinación MÁS BARATA de pasos
  // disponibles (6, 3, sueltas…) para las unidades pedidas. Convención de
  // nombres de variantes: la misma de hai-price-ladder.js.
  const money = (cents) => '$' + Math.round(cents / 100).toLocaleString('es-CL');
  const reanimar = (el, clase) => { el.classList.remove(clase); void el.offsetWidth; el.classList.add(clase); };
  const tarjetasContador = () => [...document.querySelectorAll('add-to-cart.hai-quick-add[data-hai-escalera]')];
  const escaleraDe = (el) => {
    try { return JSON.parse(el.dataset.haiEscalera || '[]'); } catch (e) { return []; }
  };

  // Combinación más barata de pasos disponibles que suma exactamente u
  // unidades. Enumeración completa: son dos o tres pasos y pocas unidades.
  const descomponer = (u, pasos) => {
    const disponibles = pasos.filter((p) => p.a && p.n > 0).sort((x, y) => y.n - x.n);
    let mejor = null;
    const buscar = (i, resto, acc, costo, comboN) => {
      if (resto === 0) {
        if (!mejor || costo < mejor.costo) mejor = { lineas: Object.assign({}, acc), costo, comboN };
        return;
      }
      if (i >= disponibles.length) return;
      const p = disponibles[i];
      for (let k = Math.floor(resto / p.n); k >= 0; k--) {
        acc[p.id] = k;
        buscar(i + 1, resto - k * p.n, acc, costo + k * p.p, k > 0 && p.n >= 3 ? Math.max(comboN, p.n) : comboN);
      }
      delete acc[p.id];
    };
    buscar(0, u, {}, 0, 0);
    return mejor;
  };

  // Unidades, total y combo de un producto según el carrito (JSON de la API).
  const estadoDesdeCarrito = (cart, pasos) => {
    let u = 0, total = 0, comboN = 0;
    (cart.items || []).forEach((item) => {
      const paso = pasos.find((p) => p.id === item.variant_id);
      if (!paso) return;
      u += paso.n * item.quantity;
      total += item.final_line_price;
      if (paso.n >= 3) comboN = Math.max(comboN, paso.n);
    });
    return { u, total, comboN };
  };

  // Nota bajo el contador (decisión de Andrés, 09-sep-2026): NUNCA el gasto
  // acumulado, que hace saliente el dolor de pagar justo cuando se decide
  // otra unidad. Solo en productos con escalera y siempre en positivo: antes
  // del combo, el objetivo cercano ("Lleva 3 y ahorras $X"); al llegar, la
  // recompensa ("Combo de 3 · ahorras $X"). El ahorro es la resta entre
  // pagar sueltas y pagar el combo, con los precios que Shopify dio al
  // renderizar: nunca inventa un descuento. Sin escalera no hay nota y el
  // subtítulo sigue a la vista.
  const notaEscalera = (pasos, u) => {
    const combos = pasos.filter((p) => p.n >= 3).sort((a, b) => a.n - b.n);
    if (!combos.length) return null;
    const suelta = pasos.find((p) => p.n === 1) || pasos.slice().sort((a, b) => a.n - b.n)[0];
    const unitario = suelta.p / suelta.n;
    const ahorro = (p) => Math.round(p.n * unitario - p.p);
    const logrado = combos.filter((p) => p.n <= u).pop();
    const tope = combos[combos.length - 1].n;
    // El monto va aparte: se pinta en el rojo de marca (el rojo de "pagas
    // menos" de las tarjetas), la frase queda en steel.
    if (logrado && (logrado.n === u || u > tope) && ahorro(logrado) > 0) {
      return { tag: 'Combo de ' + logrado.n, texto: 'ahorras ', monto: money(ahorro(logrado)) };
    }
    const siguiente = combos.find((p) => p.n > u && p.a && ahorro(p) > 0);
    if (siguiente) {
      const verbo = logrado ? 'Con ' + siguiente.n + ' ahorras ' : 'Lleva ' + siguiente.n + ' y ahorras ';
      return { tag: null, texto: verbo, monto: money(ahorro(siguiente)) };
    }
    if (logrado && ahorro(logrado) > 0) return { tag: 'Combo de ' + logrado.n, texto: 'ahorras ', monto: money(ahorro(logrado)) };
    return null;
  };

  const pintarContador = (el, est) => {
    const extras = el.closest('.card__extras');
    const card = el.closest('.card-container') || el.closest('.card') || extras;
    const stepper = extras && extras.querySelector('.hai-stepper');
    const hint = card && card.querySelector('.hai-stepper__hint');
    if (!stepper || !hint) return;
    // La nota se dibuja SOBRE el hueco del subtítulo: la caja del subtítulo se
    // queda con su alto y su texto invisible, así la tarjeta no cambia ni un
    // pixel al agregar; al volver a cero (o si no hay nota) el subtítulo se ve.
    // Sin subtítulo, la nota va bajo el contador.
    const desc = card && card.querySelector('.card__short-description');
    if (desc && hint.parentElement !== desc) desc.appendChild(hint);
    const n = stepper.querySelector('.hai-stepper__n');
    if (n.textContent !== String(est.u)) { n.textContent = est.u; if (!REDUCIDO) reanimar(n, 'is-flip'); }
    const nota = est.u > 0 ? notaEscalera(escaleraDe(el), est.u) : null;
    if (est.u > 0) {
      stepper.hidden = false;
      if (nota) {
        hint.hidden = false;
        hint.textContent = '';
        if (nota.tag) {
          const tag = document.createElement('span');
          tag.className = 'hai-stepper__tag';
          tag.textContent = nota.tag;
          hint.append(tag, ' ');
        }
        hint.append(nota.texto);
        const monto = document.createElement('span');
        monto.className = 'hai-stepper__monto';
        monto.textContent = nota.monto;
        hint.append(monto);
        if (desc) desc.classList.add('hai-con-contador');
      } else {
        hint.hidden = true;
        if (desc) desc.classList.remove('hai-con-contador');
      }
      // Reflow forzado entre quitar hidden y poner la clase: así el fundido
      // corre desde el estado oculto sin depender de requestAnimationFrame,
      // que el navegador de pruebas congela y algunos móviles retrasan.
      void stepper.offsetWidth;
      extras.classList.add('is-in-cart');
    } else {
      extras.classList.remove('is-in-cart');
      if (desc) desc.classList.remove('hai-con-contador');
      setTimeout(() => {
        if (extras.classList.contains('is-in-cart')) return;
        stepper.hidden = true;
        hint.hidden = true;
      }, 220);
    }
    el.dataset.haiQty = est.u;
    el.dataset.haiTotal = est.total;
  };

  // Primer pintado con lo que Liquid dejó en la tarjeta, sin animar y sin
  // pedir nada al servidor. Idempotente: mira el DOM, no una marca externa.
  const pintarInicial = () => {
    tarjetasContador().forEach((el) => {
      if (el.dataset.haiListo) return;
      el.dataset.haiListo = '1';
      const extras = el.closest('.card__extras');
      if (!extras) return;
      extras.classList.add('hai-sin-transicion');
      pintarContador(el, { u: parseInt(el.dataset.haiQty || '0', 10), total: parseInt(el.dataset.haiTotal || '0', 10), comboN: parseInt(el.dataset.haiCombo || '0', 10) });
      setTimeout(() => extras.classList.remove('hai-sin-transicion'), 350);
    });
  };

  /* ---- 7. Envío gratis: línea fija y aviso al agregar (21-oct-2026) ---- */
  // La línea (snippets/hai-envio-linea.liquid) trae el umbral y las frases en
  // data-*; aquí solo se elige el estado con el carrito que llega y se pinta
  // la misma frase en la línea y, tras un alta, en el aviso "Agregado". Los
  // números son los de Shopify (total_price del carrito, ajuste del tema).
  const lineaEnvio = () => document.querySelector('[data-hai-envio]');
  const dinero = (centavos) => '$' + Math.round(centavos / 100).toLocaleString('es-CL');
  const escaparHtml = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';
  let envioEsperado = 0;
  const pintarEnvio = (cart) => {
    const linea = lineaEnvio();
    const umbral = linea ? parseInt(linea.dataset.umbral || '0', 10) : 0;
    if (!linea || !umbral || !cart) return;
    const total = cart.total_price || 0;
    const estado = !cart.item_count ? 'base' : (total < umbral ? 'falta' : 'listo');
    let texto = escaparHtml(estado === 'base' ? linea.dataset.base : linea.dataset.listo);
    if (estado === 'falta') {
      const partes = String(linea.dataset.falta || '').split('[falta]');
      texto = escaparHtml(partes[0] || '') + '<b>' + dinero(umbral - total) + '</b>' + escaparHtml(partes[1] || '');
    }
    const nodo = linea.querySelector('.hai-envio-linea__texto');
    if (nodo && (linea.dataset.estado !== estado || nodo.innerHTML !== texto)) {
      nodo.innerHTML = texto;
      linea.dataset.estado = estado;
    }
    if (estado === 'base' || !toastNodo || !envioEsperado || Date.now() - envioEsperado > 6000) return;
    if (!toastNodo.classList.contains('is-visible') || toastNodo.classList.contains('hai-toast--error')) return;
    envioEsperado = 0;
    const envio = toastNodo.querySelector('.hai-toast__envio');
    if (!envio) return;
    const pct = estado === 'listo' ? 100 : Math.round((total / umbral) * 100);
    envio.innerHTML = '<span class="hai-toast__envio-texto">' + (estado === 'listo' ? CHECK : '') + '<span>' + texto + '</span></span>' +
      '<span class="hai-toast__barra" aria-hidden="true"><i style="width:' + pct + '%"></i></span>';
    envio.hidden = false;
    // Que alcance a leerse: el aviso se queda 3 s más desde que aparece la frase.
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastNodo.classList.remove('is-visible'), 3000);
  };

  const sincronizarContadores = (cart) => {
    tarjetasContador().forEach((el) => pintarContador(el, estadoDesdeCarrito(cart, escaleraDe(el))));
    pintarEnvio(cart);
    // Para quien necesite el carrito al día (assets/hai-mensajes.js: "no mostrar
    // si ya tiene productos en el carrito").
    document.dispatchEvent(new CustomEvent('hai:carrito', { detail: { cart } }));
  };
  let syncTimer = null;
  const resincronizar = (retraso) => {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(() => {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then((r) => r.json())
        .then(sincronizarContadores)
        .catch(() => {});
    }, retraso || 0);
  };

  // Cambios de cantidad: vista optimista al toque y UNA llamada 300 ms después
  // del último toque. Una respuesta que llega tarde (hay un cambio más nuevo
  // en camino) se descarta por número de secuencia.
  const pendientesQty = new WeakMap();
  const enviarCantidad = (el, pasos, u, seq, st) => {
    const combo = u > 0 ? descomponer(u, pasos) : { lineas: {}, costo: 0, comboN: 0 };
    if (!combo) {
      aviso('No hay stock para esa cantidad.', true);
      resincronizar(0);
      return;
    }
    const updates = {};
    pasos.forEach((p) => { updates[p.id] = combo.lineas[p.id] || 0; });
    // Ayudante del tema: da la lista de secciones y las repinta (burbuja y
    // drawer) sin abrir el drawer, igual que el alta rápida.
    const ayudante = document.createElement('add-to-cart');
    ayudante.className = 'hai-quick-add hai-quick-add--oculto';
    ayudante.hidden = true;
    document.body.appendChild(ayudante);
    const secciones = [...new Set(ayudante.getSectionsToRender().map((s) => s.id))];
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates, sections: secciones, sections_url: window.location.pathname })
    })
      .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (seq !== st.seq) return;
        if (!ok || j.status >= 400) {
          aviso(j.description || j.message || 'No se pudo actualizar el carrito.', true);
          resincronizar(0);
          return;
        }
        try { ayudante.renderContents(j); } catch (e) { /* secciones ya pintadas */ }
        sincronizarContadores(j);
        const icono = iconoCarrito();
        if (icono) rebotar(icono);
        document.dispatchEvent(new CustomEvent('hai:carrito:actualizado', { detail: { cart: j } }));
      })
      .catch(() => { aviso('No se pudo actualizar el carrito.', true); resincronizar(0); })
      .finally(() => ayudante.remove());
  };

  document.addEventListener('click', (event) => {
    const b = event.target.closest && event.target.closest('.hai-stepper__btn');
    if (!b) return;
    const extras = b.closest('.card__extras');
    const el = extras && extras.querySelector('add-to-cart.hai-quick-add[data-hai-escalera]');
    if (!el) return;
    event.preventDefault();
    const pasos = escaleraDe(el);
    const st = pendientesQty.get(el) || { seq: 0, u: parseInt(el.dataset.haiQty || '0', 10) };
    st.u = Math.max(0, st.u + (b.hasAttribute('data-hai-mas') ? 1 : -1));
    // Vista optimista con los precios que Shopify dio al renderizar; la
    // respuesta del carrito la corrige si difiere (descuentos, stock).
    const est = st.u > 0 ? descomponer(st.u, pasos) : { costo: 0, comboN: 0 };
    pintarContador(el, { u: st.u, total: est ? est.costo : 0, comboN: est ? est.comboN : 0 });
    clearTimeout(st.timer);
    st.seq += 1;
    const seq = st.seq;
    st.timer = setTimeout(() => enviarCantidad(el, pasos, st.u, seq, st), 300);
    pendientesQty.set(el, st);
  });

  // Cualquier alta (tarjeta, hero, "Quiero probarlas", ficha) o cambio desde el
  // drawer del tema: releer el carrito (tras el compás verde del alta).
  document.addEventListener('ajaxProduct:added', () => resincronizar(VERDE_MS));
  // Cambios desde el drawer o la página del carrito (cantidad, quitar): el
  // tema emite cart:updated con la respuesta COMPLETA del carrito en
  // detail.cart (texto JSON). Se sincroniza desde ahí, sin ninguna llamada
  // extra; solo si no se puede leer, se relee el carrito.
  document.addEventListener('cart:updated', (event) => {
    try {
      const cart = event.detail && event.detail.cart;
      sincronizarContadores(typeof cart === 'string' ? JSON.parse(cart) : cart);
    } catch (e) {
      resincronizar(0);
    }
  });
  // Ojo: PUB_SUB_EVENTS es un const de global.js, NO cuelga de window; el
  // guard anterior (window.PUB_SUB_EVENTS) nunca se cumplía. El drawer y la
  // página del carrito (source 'cart-items') ya llegan por cart:updated con
  // los datos: se excluyen para no releer el carrito dos veces. Queda para
  // otras fuentes (el formulario de la ficha, que no emite cart:updated).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (d) => { if (!d || d.source !== 'cart-items') resincronizar(0); });
  }
  // Vuelta atrás con la página guardada en memoria (bfcache, muy común en
  // Safari móvil): la tarjeta mostraría el estado viejo; se relee el carrito.
  window.addEventListener('pageshow', (event) => { if (event.persisted) resincronizar(0); });

  /* ---- 5. Toque directo en móvil ---- */
  // En iOS el primer toque dentro de un slider dispara mouseenter (el tema lo
  // usa para pausar el autoplay y cargar imágenes) y el clic se pierde: había
  // que tocar dos veces. En touchend se lanza el clic propio y se cancela la
  // emulación de mouse. Solo si el dedo no se movió (no es un scroll).
  // 09-sep-2026 (Andrés, en producción): la TARJETA entera pedía dos toques
  // para ir a la ficha. Misma causa: <product-card-image> del tema engancha
  // pointerenter/pointerdown "de primera intención" para cargar las imágenes
  // (la segunda foto del hover) y ese cambio de contenido en el primer toque
  // hace que iOS no entregue el clic. Se suma el ancla de la tarjeta al
  // mismo mecanismo; los botones de adentro (quick add, contador) siguen
  // ganando porque closest() encuentra primero al más cercano.
  const TOQUE_SEL = 'add-to-cart.hai-quick-add, a.hai-hero-add, [data-hai-agregar], .hai-stepper__btn, a.card.card-js';
  // 09-sep-2026 (noche): umbral más tolerante (16 px / 900 ms) y el objetivo
  // se recuerda desde touchstart, por si el teclado al cerrarse mueve algo
  // entre el inicio y el fin del toque. Se probó tratar touchcancel como
  // toque y se descartó: iOS lo emite cuando el sistema se queda el gesto y
  // podía agregar al carrito mientras la persona solo quería desplazar.
  const TOQUE_MOV = 16;
  const TOQUE_MS = 900;
  let toque = null;
  document.addEventListener('touchstart', (e) => {
    const t = e.touches[0];
    toque = t ? { x: t.clientX, y: t.clientY, t: Date.now(), objetivo: e.target.closest ? e.target.closest(TOQUE_SEL) : null } : null;
  }, { passive: true });
  document.addEventListener('touchend', (e) => {
    const objetivo = (e.target.closest && e.target.closest(TOQUE_SEL)) || (toque && toque.objetivo);
    const inicio = toque;
    toque = null;
    if (!objetivo || !inicio) return;
    const t = e.changedTouches && e.changedTouches[0];
    if (t && (Math.abs(t.clientX - inicio.x) > TOQUE_MOV || Math.abs(t.clientY - inicio.y) > TOQUE_MOV)) return;
    if (Date.now() - inicio.t > TOQUE_MS) return;
    // 10-sep-2026: un toque abre la ficha en TODA la tarjeta, foto incluida.
    // Ver la segunda foto es mantener presionado (:active en hai-cards.css);
    // si el dedo se queda más de TOQUE_MS, arriba se sale sin clic: eso ES
    // el gesto de mirar.
    if (e.cancelable) e.preventDefault();
    objetivo.click();
  }, { passive: false });

  /* ---- 5b. Mantener el dedo en la tarjeta = ver la segunda foto (25-oct-2026) ---- */
  // Lo hacía solo CSS con :active (hai-cards.css), pero el navegador del teléfono no siempre lo aplica en un dedo
  // largo: Chrome lo pierde desde el segundo dedo largo de la misma página (scripts/diseno/segunda-foto.mjs) y
  // Safari lo condiciona a sus propias reglas. La clase .hai-segunda se pone a los 200 ms de apoyar el dedo quieto y
  // se quita al soltar, al moverlo más de 10 px (es un desplazamiento) o si el sistema cancela el toque. Un toque
  // corto no alcanza a ponerla: abre la ficha como siempre (bloque 5).
  const SEGUNDA_MS = 200;
  let segunda = null;
  const soltarSegunda = () => {
    if (!segunda) return;
    clearTimeout(segunda.reloj);
    segunda.card.classList.remove('hai-segunda');
    segunda = null;
  };
  document.addEventListener('touchstart', (e) => {
    soltarSegunda();
    const t = e.touches.length === 1 ? e.touches[0] : null;
    const card = t && e.target.closest ? e.target.closest('a.card.card-js') : null;
    if (!card || !card.querySelector('.have-second-media')) return;
    segunda = { card, x: t.clientX, y: t.clientY, reloj: setTimeout(() => card.classList.add('hai-segunda'), SEGUNDA_MS) };
  }, { passive: true });
  document.addEventListener('touchmove', (e) => {
    const t = e.touches[0];
    if (segunda && t && (Math.abs(t.clientX - segunda.x) > 10 || Math.abs(t.clientY - segunda.y) > 10)) soltarSegunda();
  }, { passive: true });
  document.addEventListener('touchend', soltarSegunda, { passive: true });
  document.addEventListener('touchcancel', soltarSegunda, { passive: true });

  const iniciar = () => {
    recolocar();
    marcarHero();
    pintarInicial();
    // Recomendados, vistos recientemente y el drawer llegan por fetch tardío:
    // se observa el body; recolocar y pintarInicial son idempotentes (miran
    // el DOM, no una marca externa).
    new MutationObserver(() => { recolocar(); pintarInicial(); }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
